import { Calendar, FileEdit, Menu, RefreshCcw, Trash2 } from "lucide-react";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "randmarcomps";
import { Opportunity } from "../../stores/opportunities/Opportunity";
import DeleteOpportunityWrapper from "./DeleteOpportunityWrapper";
import EditOpportunityWrapper from "./EditOpportunityWrapper";
import RenewOpportunityWrapper from "./RenewOpportunityWrapper";

interface OpportunityActionsProps {
  opportunity: Opportunity;
  onUpdated?: () => void;
}

export default function OpportunityActions({ opportunity, onUpdated }: OpportunityActionsProps) {
  const bidNumber = opportunity.bidNumber || "";
  const disableDelete = Boolean(opportunity.details && opportunity.details.length > 0);
  const disableRenew = Boolean((opportunity.details?.length ?? 0) === 0 && (opportunity.resellers?.length ?? 0) === 0);

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="outline" className="rounded-xl">
          <Menu className="mr-2 h-4 w-4" aria-hidden="true" />
          Actions
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel className="text-xs font-semibold uppercase tracking-wide text-gray-500">
          Edit
        </DropdownMenuLabel>
        <DropdownMenuGroup>
          <EditOpportunityWrapper
            bidNumber={bidNumber}
            fieldName="Opportunity"
            label="Opportunity name"
            currentValue={opportunity.opportunity}
            onUpdated={onUpdated}
          >
            <DropdownMenuItem className="cursor-pointer">
              <FileEdit className="mr-2 h-4 w-4" aria-hidden="true" />
              Name
            </DropdownMenuItem>
          </EditOpportunityWrapper>
          <EditOpportunityWrapper
            bidNumber={bidNumber}
            fieldName="EndDate"
            label="End date"
            currentValue={opportunity.endDate}
            inputType="date"
            onUpdated={onUpdated}
          >
            <DropdownMenuItem className="cursor-pointer">
              <Calendar className="mr-2 h-4 w-4" aria-hidden="true" />
              End date
            </DropdownMenuItem>
          </EditOpportunityWrapper>
        </DropdownMenuGroup>

        <DropdownMenuSeparator />

        <DropdownMenuLabel className="text-xs font-semibold uppercase tracking-wide text-gray-500">
          Utilities
        </DropdownMenuLabel>
        <DropdownMenuGroup>
          <RenewOpportunityWrapper opportunity={opportunity} disabled={disableRenew} onUpdated={onUpdated}>
            <DropdownMenuItem className="cursor-pointer" disabled={disableRenew}>
              <RefreshCcw className="mr-2 h-4 w-4" aria-hidden="true" />
              Renew
            </DropdownMenuItem>
          </RenewOpportunityWrapper>

          <DeleteOpportunityWrapper
            bidNumber={bidNumber}
            disabled={disableDelete}
            buttonTitle="Delete opportunity"
            text={disableDelete ? "Remove all part numbers before deleting." : "Delete forever?"}
          >
            <DropdownMenuItem className="cursor-pointer text-rose-600 focus:text-rose-600" disabled={disableDelete}>
              <Trash2 className="mr-2 h-4 w-4" aria-hidden="true" />
              Delete
            </DropdownMenuItem>
          </DeleteOpportunityWrapper>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
